import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import auth from "./locales/ua/auth.json";
import contactUs from "./locales/ua/contactUs.json";
import errors from "./locales/ua/errors.json";
import footer from "./locales/ua/footer.json";
import forgotpassword from "./locales/ua/forgotpassword.json";
import header from "./locales/ua/header.json";
import homePage from "./locales/ua/homePage.json";
import inviteCode from "./locales/ua/inviteCode.json";
import onboarding from "./locales/ua/onboarding.json";
import organizationSignup from "./locales/ua/organization-signup.json";
import profile from "./locales/ua/profile.json";
import questionnaires from "./locales/ua/questionnaires.json";
import resetpassword from "./locales/ua/resetpassword.json";
import results from "./locales/ua/results.json";
import signin from "./locales/ua/signin.json";
import signup from "./locales/ua/signup.json";
import slices from "./locales/ua/slices.json";
import surveyTransition from "./locales/ua/survey-transition.json";

export const resources = {
  ua: {
    auth,
    homePage,
    footer,
    header,
    results,
    questionnaires,
    inviteCode,
    contactUs,
    onboarding,
    organizationSignup,
    signup,
    signin,
    forgotpassword,
    resetpassword,
    profile,
    surveyTransition,
    slices,
    errors,
  },
} as const;

export const defaultNS = "homePage";

void i18n.use(initReactI18next).init({
  compatibilityJSON: "v3",
  resources,
  defaultNS,
  lng: "ua",
  ns: Object.keys(resources.ua),
  interpolation: { escapeValue: false },
});

export default i18n;
